"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ERROR_MESSAGES_CLASS = exports.ERROR_BORDER_CLASS_FIELD = exports.ERROR_BORDER_CLASS_DIV = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _semanticUiReact = require("semantic-ui-react");
var _utils = require("../../../../../common/utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MANAGED_PROPS = ['errorMessages', 'optional', 'size', 'hintText'];
var ERROR_BORDER_CLASS_DIV = 'errorBorderLine';
exports.ERROR_BORDER_CLASS_DIV = ERROR_BORDER_CLASS_DIV;
var ERROR_BORDER_CLASS_FIELD = 'errorFieldBorder';
exports.ERROR_BORDER_CLASS_FIELD = ERROR_BORDER_CLASS_FIELD;
var ERROR_MESSAGES_CLASS = 'errorMessages';
exports.ERROR_MESSAGES_CLASS = ERROR_MESSAGES_CLASS;
var withValidation = function withValidation(WrappedComponent) {
  var withLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var isInline = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (props) {
    var filteredProps = _lodash.default.omit(props, MANAGED_PROPS);
    var displayError = props.displayError,
      errorMessages = props.errorMessages,
      id = props.id,
      label = props.label,
      optional = props.optional,
      size = props.size,
      hintText = props.hintText,
      additionalcn = props.additionalcn;
    var paddedError = _lodash.default.get(props, 'paddedError', true);
    var width = (0, _utils.getTshirtSizeCol)(size);
    var errorId = id + '-error';
    var showLabelDiv = optional || withLabel && label;
    return isInline ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, {
      width: width
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: displayError ? ERROR_BORDER_CLASS_DIV : ''
    }, showLabelDiv && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingBottom: '4px'
      }
    }, withLabel && /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: id || label + 'id'
    }, /*#__PURE__*/_react.default.createElement("b", null, label)), optional && /*#__PURE__*/_react.default.createElement("i", {
      className: "optionalLabel"
    }, "Optional"), "\xA0"), /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({}, filteredProps, {
      errorId: errorId,
      formControlClassName: displayError ? ERROR_BORDER_CLASS_FIELD : ''
    })), /*#__PURE__*/_react.default.createElement("i", null, hintText), displayError && /*#__PURE__*/_react.default.createElement("div", {
      className: ERROR_MESSAGES_CLASS,
      id: errorId
    }, errorMessages)))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "formControl ".concat(displayError ? ERROR_BORDER_CLASS_DIV : '')
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, {
      width: width
    }, showLabelDiv && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingBottom: '4px'
      }
    }, withLabel && /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: id || label + 'id'
    }, /*#__PURE__*/_react.default.createElement("b", null, label)), optional && /*#__PURE__*/_react.default.createElement("i", {
      className: "optionalLabel"
    }, "Optional"), "\xA0"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({}, filteredProps, {
      errorId: errorId,
      formControlClassName: displayError ? ERROR_BORDER_CLASS_FIELD : ''
    }))), !paddedError && [/*#__PURE__*/_react.default.createElement("i", {
      key: "hint-text"
    }, hintText), displayError && /*#__PURE__*/_react.default.createElement("div", {
      className: "errorMessages ".concat(additionalcn),
      id: errorId
    }, errorMessages)]), paddedError && [/*#__PURE__*/_react.default.createElement("i", {
      key: "hint-text",
      className: "hintText"
    }, hintText), displayError && /*#__PURE__*/_react.default.createElement("div", {
      id: errorId,
      className: ERROR_MESSAGES_CLASS
    }, errorMessages)]));
  };
};
withValidation.propTypes = {
  displayError: _propTypes.default.bool,
  errorMessages: _propTypes.default.array,
  size: _propTypes.default.string,
  hintText: _propTypes.default.string,
  label: _propTypes.default.string,
  optional: _propTypes.default.bool
};
var _default = withValidation;
exports.default = _default;